module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "menu-horizon-item",
    class: [
      _vm.current ? 'menu-current' : ''
    ],
    on: {
      "click": function($event) {
        _vm._handleClick()
      }
    }
  }, [(_vm.type == 'iconfont') ? _c('span', {
    staticClass: "menu-pic"
  }, [_c('i', {
    staticClass: "icon iconfont",
    class: [
      _vm.current && _vm.currentIcon ? 'icon-' + _vm.currentIcon : 'icon-' + _vm.icon
    ]
  })]) : _vm._e(), _vm._v(" "), (_vm.type == 'image') ? _c('span', {
    staticClass: "menu-pic"
  }, [(_vm.current && _vm.currentIcon) ? _c('img', {
    attrs: {
      "src": _vm.currentIcon,
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.icon,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.tip && _vm.tip > 0) ? _c('span', {
    staticClass: "tip"
  }, [_vm._v(_vm._s(_vm.tip))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "menu-title"
  }, [_vm._v(_vm._s(_vm.title))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-65e5f8d5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menus-horizon/menus-horizon-item.vue
// module id = 259
// module chunks = 36